"use client"
import { useEffect } from "react";
import Image from "next/image";
import Breadcrumb from "./Breadcrumb";
import 'aos/dist/aos.css';
import 'aos/dist/aos.js';
import { IoStar } from "react-icons/io5";
import ApplyNowPopupModule from "../contactUs/enquire-popup-form";

const Banner = () => {

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const AOS = require('aos');
            AOS.init();
        }
    }, []);
    return (
        <div>
            <Breadcrumb />
            <section className="bg-no-repeat bg-gradient-to-r from-[#3C2140] to-[#1E0C21] w-full flex items-center py-7 lg:py-14 md:py-14">
                <div className="container">
                    <div className="grid grid-cols-12 gap-2 mx-auto items-center">
                        <div className="sm:col-span-7 col-span-12 order-2 sm:order-1">
                            <div data-aos="fade-up" data-aos-duration="1000">
                                <div className="container-div">
                                    <h1 className="text-white lg:text-5xl md:text-2xl text-xl font-semibold lg:leading-[4rem]">
                                        Delivering quality technical training 
                                    </h1>
                                    <p className="font-normal lg:text-lg md:text-[16px] text-[1rem] text-[#FFFFFF] md:pt-5 pt-3">Explore the potential for advanced <strong> SAP, AI,</strong> and other <strong>specialized</strong> training as we reimagine the essence of education. </p>
                                    <ApplyNowPopupModule  coursename={"Enquire"} source="About Us" screen="course_list"/>
                                    {/* <div className="md:flex flex-wrap md:flex-nowrap md:space-x-4  md:space-y-0 space-y-3 mt-8">
                                        <p className="m-0 text-white bg-white/10 lg:px-6 px-4 py-3 border border-white rounded flex items-center lg:text-[16px] text-[14px]">
                                        <IoStar className="me-3 text-[#C659D5] lg:text-[24px] text-[18px]"/>Domain Training</p>
                                        <p className="m-0 text-white bg-white/10 lg:px-6 px-4 py-3 border border-white rounded flex items-center lg:text-[16px] text-[14px]">
                                        <IoStar className="me-3 text-[#C659D5] lg:text-[24px] text-[18px]"/>Professional Development</p>
                                    </div> */}
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 sm:col-span-5 relative order-1 sm:order-2">
                            <div data-aos="fade-up" data-aos-duration="1000">
                                <Image
                                    height={466}
                                    width={447}
                                    src="https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/about/about-img.webp"
                                    className="max-w-full m-auto h-auto"
                                    alt="About banner img"
                                    fetchPriority="high"
                                    loading="eager"
                                    rel="preload"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Banner;